<template>
  <div class="right">
    <div class="right-inner">
      <div class="introduction">
        <h3>Introduction</h3>
        <div class="content">
          <p class="project-desc">Namaste! 🙏 My name is Animesh Manglik and I develop for Web and Mobile </p>
          <p class="project-desc">Welcome to the TL;DR version of my website which I am currently redesigning. This has been a fun experiment, make sure you interact with the phone on the left</p>
          <p class="project-desc">Hope you have a great day!</p>
        </div>
      </div>
      <education></education>
      <projects></projects>
      <playground></playground>
      <experience></experience>
      <additional></additional>
      <social></social>
    </div>
  </div>
</template>

<style type="text/css">
  .right {
    width: 50%;
    display: block;
    vertical-align: top;
    float: right;
    background-color: #F5F5F5;
  }
  .right-inner {
    padding: 20px 50px 50px 50px;
  }
  .introduction {
    margin-bottom: 10px;
  }
  .introduction .project-desc:first-child {
    margin-top: 0;
  }
  @media screen and (max-width: 1000px) {
    .right {
      display: block;
      width: 100%;
    }
    .right-inner {
      padding: 20px;
    }
  }
</style>


<script type="text/javascript">
  import Experience from './sections/Experience';
  import Projects from './sections/Projects';
  import Additional from './sections/Additional';
  import Education from './sections/Education';
  import Playground from './sections/Playground';
  import Social from './sections/Footer';

  export default {
    name: 'right',
    components: {
      Experience,
      Projects,
      Additional,
      Education,
      Playground,
      Social,
    },
  };
</script>



// WEBPACK FOOTER //
// Right.vue?169a6690